<template>
		<div class="itoggle">
			
			<!-- <toggle-button
				@change="changeToggle"
				:value="value"
				
				:labels="{checked: 'On', unchecked: 'Off'}"
			/> -->
			<label>
				{{label}}
				<label class="switch">
				  <input type="checkbox" :checked="value" @change="changeToggle">
				  <span class="slider round"></span>
				</label>
			</label>
		</div>
</template>

<script>
/*
	import Vue from 'vue';

	import ToggleButton from 'vue-js-toggle-button';
	Vue.use(ToggleButton);*/
export default {

  name: 'i-toggle',
  props:{
  	value:{type:[Boolean,Number],default:false},
  	label:{type:String, default: 'label'}
  },
  methods:{
	changeToggle(v){
		this.$emit('input', v.target.checked);
		//this.$emit('change', v);
	}},
  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>

.itoggle{
  margin:4px 0;
}
label{
	font-size:14px;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  vertical-align: middle;
}

/* Hide default HTML checkbox */
.switch input {display:none;}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>